export default __webpack_public_path__ + "ee77d96fc0fd2075ed15ba88bfac78fb.png";